import { DocumentClassificationInvalidReason as a, DocumentClassificationStatus as u, ClassificationConfidence as l, MATURITY_CONFIG as f, MaturityLevelKey as d, TimeFilter as c, LANGUAGE_LABEL as E, LanguageCode as g, MAX_ASSESSMENT_TITLE_LENGTH as M } from "@libs/constants";
import { camelizeKeys as Y, snakeToCamel as q } from "@libs/types";
function v(e) {
  return e === u.COMPLETED || e === u.FAILED;
}
function h(e) {
  var t, n;
  return e == null ? !1 : typeof e == "string" ? e.trim().length > 0 : !!((t = e.en) != null && t.trim() || (n = e.ar) != null && n.trim());
}
const A = /* @__PURE__ */ new Set([
  a.WRONG_FORMAT,
  a.WEAK_MATCH
]);
function C(e) {
  return e != null && !A.has(e);
}
function D(e) {
  return e === a.WEAK_MATCH;
}
function R(e) {
  return e.classificationStatus === u.COMPLETED && D(e.invalidReason);
}
function B(e) {
  var t, n;
  return !!((t = e.suggestedDomainKey) != null && t.trim()) && !!((n = e.suggestedDocumentKey) != null && n.trim());
}
function p(e) {
  const t = /\.([^.\\/]+)$/.exec((e ?? "").trim());
  return t ? t[1].toLowerCase() : "";
}
function m(e) {
  return (e ?? []).map((t) => t.replace(/^\./, "").toLowerCase()).filter(Boolean);
}
function S(e, t, n) {
  const i = p(e), r = m(t), o = m(n);
  return !i || r.length === 0 && o.length === 0 ? "unknown" : r.includes(i) ? "standard" : o.includes(i) || o.length === 0 ? "accepted" : "unsupported";
}
function w(e) {
  var r, o, s;
  const t = !!((r = e.matchedStandardDocumentKey) != null && r.trim()) && h(e.matchedStandardDocumentName);
  if (!!((o = e.suggestedDomainKey) != null && o.trim() || (s = e.suggestedDocumentKey) != null && s.trim()))
    return a.WRONG_DOMAIN;
  if (!t)
    return a.NO_MATCH;
  if (e.classificationConfidence === l.LOW)
    return a.WEAK_MATCH;
  if (!(e.classificationConfidence === l.MEDIUM || e.classificationConfidence === l.HIGH))
    return a.NO_MATCH;
  switch (S(e.fileName, e.standardFormat, e.acceptedFormats)) {
    case "accepted":
      return a.WRONG_FORMAT;
    case "unsupported":
      return a.UNSUPPORTED_FORMAT;
    default:
      return null;
  }
}
function T(e) {
  const t = e.classificationMetadata;
  return !(!t || t.classificationStatus !== u.COMPLETED || C(t.invalidReason));
}
function x(e) {
  var i;
  if (!e.isApplicable) return [];
  const t = ((i = e.frameworkDomain) == null ? void 0 : i.standardDocuments) ?? [];
  if (t.length === 0) return [];
  const n = new Set(
    (e.documents ?? []).filter(
      (r) => {
        var o;
        return !r.deleted && T(r) && ((o = r.classificationMetadata) == null ? void 0 : o.isRequiredDocumentMatch) === !0;
      }
    ).map((r) => r.classificationMetadata.matchedStandardDocumentKey).filter((r) => r != null)
  );
  return t.filter((r) => !n.has(r.key));
}
function P(e, t = "percentage") {
  const i = Object.values(f).find((o) => {
    const s = o[t];
    return e >= s.min && e <= s.max;
  });
  if (i)
    return i;
  const r = f[d.PIONEER];
  return e > r[t].max ? r : f[d.ABSENCE_OF_CAPABILITIES];
}
function b(e) {
  return typeof e == "object" && e !== null;
}
function H(e) {
  return e.replace(/([a-z0-9])([A-Z])/g, "$1_$2").replace(/([A-Z]+)([A-Z][a-z0-9]+)/g, "$1_$2").toLowerCase();
}
function K(e) {
  const t = /* @__PURE__ */ new Date(), n = new Date(t);
  switch (e) {
    case c.TODAY:
      n.setHours(0, 0, 0, 0);
      break;
    case c.THIS_WEEK:
      n.setDate(n.getDate() - 7);
      break;
    case c.THIS_MONTH:
      n.setMonth(n.getMonth() - 1);
      break;
    case c.THIS_QUARTER:
      n.setMonth(n.getMonth() - 3);
      break;
  }
  return n;
}
function F(e) {
  return E[e] ?? e;
}
const k = (e) => {
  if (e === 0) return "0 Bytes";
  const t = 1024, n = ["Bytes", "KB", "MB", "GB"], i = Math.floor(Math.log(e) / Math.log(t));
  return parseFloat((e / Math.pow(t, i)).toFixed(2)) + " " + n[i];
};
function N(e) {
  const t = e.split(".").pop();
  return t ? t.toLowerCase() : "";
}
function _(e, t, n, i) {
  const r = Math.ceil(n / t), o = e < r, s = e > 1;
  return {
    currentPage: e,
    totalCount: n,
    currentCount: i,
    pageSize: t,
    totalPages: r,
    hasNextPage: o,
    hasPrevPage: s,
    nextPageNumber: o ? e + 1 : null,
    prevPageNumber: s ? e - 1 : null
  };
}
function G(e, t, n) {
  const i = (t - 1) * n, r = e.slice(i, i + n);
  return { rows: r, meta: _(t, n, e.length, r.length) };
}
function z(e, t) {
  return [...e].sort(
    (n, i) => (t(n) ?? Number.MAX_SAFE_INTEGER) - (t(i) ?? Number.MAX_SAFE_INTEGER)
  );
}
function O(e) {
  if (!e || !e.includes(".")) return;
  const t = N(e);
  return t ? `.${t}` : void 0;
}
function W(e, {
  allowedFileTypes: t,
  maxFileSizeMb: n,
  maxFiles: i,
  currentFileCount: r = 0
}) {
  if (i !== void 0 && r >= i)
    return { valid: !1, error: "maxFiles" };
  if (e.size > n * 1024 * 1024)
    return { valid: !1, error: "size" };
  const o = O(e.name);
  return !o || !t.includes(o) ? { valid: !1, error: "type" } : { valid: !0 };
}
function U(e) {
  return e.replace(new RegExp("(\\p{Emoji_Presentation}|\\p{Emoji}\\uFE0F)", "gu"), "").replace(/\u200D/g, "").replace(/[\uFE00-\uFE0F]/g, "").replace(/[\u{1F3FB}-\u{1F3FF}]/gu, "").replace(/\s+/g, " ").trim();
}
function y(e) {
  return Array.isArray(e) ? e.map((t) => y(t)) : {
    code: e,
    label: F(e)
  };
}
function j(e, t) {
  if (!e) return null;
  if (e[t])
    return e[t];
  if (e[g.EN])
    return e[g.EN];
  const n = Object.values(e);
  return n.length > 0 ? n[0] : null;
}
function $(e) {
  const t = (e ?? "").trim();
  for (const n of t) {
    if (new RegExp("\\p{Script=Arabic}", "u").test(n)) return "rtl";
    if (new RegExp("\\p{Script=Latin}", "u").test(n)) return "ltr";
  }
  return "ltr";
}
function L(e, t) {
  if (e.length <= t) return e;
  const n = e.substring(0, t), i = n.charCodeAt(n.length - 1);
  return i >= 55296 && i <= 56319 ? n.slice(0, -1) : n;
}
const V = (e) => L(e, M);
export {
  _ as buildPaginationMeta,
  H as camelToSnake,
  Y as camelizeKeys,
  B as canMoveToSuggestedDomain,
  S as classifyDocumentFormat,
  w as computeDocumentClassificationInvalidReason,
  x as computeMissingStandardDocuments,
  $ as detectDirection,
  N as extractFileExtension,
  j as extractLocalizedContent,
  k as formatFileSize,
  K as getDateFilterStartDate,
  O as getFileExtension,
  F as getLanguageLabel,
  P as getMaturityByValue,
  h as hasMatchedStandardDocumentDisplayName,
  T as hasValidClassification,
  C as isBlockingClassificationInvalidReason,
  b as isErrorWithCode,
  v as isTerminalClassificationStatus,
  D as isWeakClassificationMatch,
  y as mapToLanguageMeta,
  R as needsClassificationDecision,
  G as paginateArray,
  U as removeEmojis,
  q as snakeToCamel,
  z as sortByOrderIndex,
  V as truncateAssessmentTitle,
  L as truncateSafely,
  W as validateUploadFile
};
